import React, { Component } from 'react'
import { Alert } from 'antd'

class Denied extends Component {

    render() {
        return (
            <Alert message="Não autorizado!" type="error" showIcon />
        )
    }
}

export default Denied



// WEBPACK FOOTER //
// ./src/components/Denied.js